import { useState, useEffect } from 'react';

export const useAnimatedValue = (start, end, config = {}) => {
  const [animatedValue, setAnimatedValue] = useState(start);

  const duration = config.duration || 250;
  useEffect(() => {
    let animationFrame;
    let startTime;

    const animate = (time) => {
      if (!startTime) startTime = time;
      const elapsed = time - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const increment = (end - start) * progress;
      setAnimatedValue(start + increment);
      if (progress < 1) {
        animationFrame = global.requestAnimationFrame(animate);
      }
    };

    animationFrame = global.requestAnimationFrame(animate);
    return () => global.cancelAnimationFrame(animationFrame);
  }, [start, end, duration]);

  return animatedValue;
};
